import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import {
  deactivateChubbInsurance,
  submitChubbBillInsuranceOrders,
} from "./services";

export const useChubbBillInsuranceOrdersMutation = () =>
  useMutation({
    mutationFn: submitChubbBillInsuranceOrders,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["insurance"],
      });
      void queryClient.invalidateQueries({
        queryKey: ["jointBillServicePeriodData", variables.jointBillServiceId],
      });
      void queryClient.invalidateQueries({
        queryKey: ["jointBillServiceSummaries"],
      });
      void queryClient.invalidateQueries({
        queryKey: ["additionalServices", "files"],
      });
    },
  });

export const useDeactivateChubbBillInsuranceMutation = () =>
  useMutation({
    mutationFn: (jointBillServiceId: number) =>
      deactivateChubbInsurance(jointBillServiceId),
    onSuccess: (_data, jointBillServiceId) => {
      void queryClient.invalidateQueries({
        queryKey: ["insurance"],
      });
      void queryClient.invalidateQueries({
        queryKey: ["jointBillServicePeriodData", jointBillServiceId],
      });
      void queryClient.invalidateQueries({
        queryKey: ["jointBillServiceSummaries"],
      });
      void queryClient.invalidateQueries({
        queryKey: ["additionalServices", "files"],
      });
    },
  });
